import React, { useEffect, useState } from "react";
import Breadcrumbs from "../based/Breadcrumbs";
import CommonTable from "../based/CommonTable";
import { INITPAGING, NOTIFY } from "../based/Constants";
import { ConfirmDialog } from "../based/Dialog";
import Loading from "../based/Loading";
import { Notify } from "../based/Notify";
import EmbroideryServices from "../based/services/EmbroideryServices";
import PatternUploadModal from "./components/PatternUploadModal";

function EmbroideryPatternList(props) {
    const [isBusy, setIsBusy] = useState(false);
    const [datas, setDatas] = useState([]);
    const [paging, setPaging] = useState({ ...INITPAGING, designId: 0, designSizeId: 0, colorVariantId: 0 });
    const [isShowModal, setIsShowModal] = useState(false);
    const [selectId, setSelectId] = useState(0);

    useEffect(() => {
        _getData(paging);
    }, []);

    async function _getData(newPaging) {
        setIsBusy(true);
        let [err, data] = await EmbroideryServices.GetDesignFiles(newPaging);
        if (!err && data) {
            setDatas(data.listObjects);
            setPaging(data.paging);
        } else {
            setDatas([]);
            setPaging(newPaging);
        }
        setIsBusy(false);
    }

    function _handleDelete(id) {
        ConfirmDialog("Xác nhận xóa?", "Xin vui lòng xác nhận để xóa họa tiết thêu này", () => {
            return new Promise(async (resolve, reject) => {
                let [err, data] = await EmbroideryServices.DeleteDesignFile(id);
                if (!err && data) {
                    resolve({ title: "Thành công", msg: "Xóa thành công." });
                    _getData(paging);
                } else {
                    Notify(NOTIFY.WARNING, "Có lỗi", "Có lỗi xảy ra trong quá trình xóa.");
                }
            });
        });
    }

    function _renderAction() {
        return (
            <button
                className='btn btn-custom'
                onClick={() => {
                    setSelectId(0);
                    setIsShowModal(true);
                }}
            >
                <i className='fa fa-plus mr-2'></i>
                Thêm họa tiết thêu
            </button>
        );
    }

    function _renderHeader() {
        return (
            <thead>
                <tr className='text-center'>
                    <th>Tên</th>
                    <th>Preview</th>
                    <th>File thêu</th>
                    <th>Tag</th>
                    <th>Hành động</th>
                </tr>
            </thead>
        );
    }

    function _renderBody() {
        return (
            <tbody>
                {datas && datas.length > 0 ? (
                    datas.map((item, idx) => {
                        return (
                            <tr key={idx}>
                                <td>{item.label}</td>
                                <td className='text-center'>{item.fileUrl && item.fileFormat == "png" ? <img src={item.fileUrl} alt={item.label} style={{ width: 60, height: 60, objectFit: "contain" }} /> : "-"}</td>
                                <td className='text-center'>{(item.fileFormat || "").toUpperCase()}</td>
                                <td className='text-center'>{item.boundingWidthMm > 0 ? `${item.boundingWidthMm}mm` : "-"}</td>
                                <td className='text-center'>
                                    <button
                                        className='btn btn-custom m-1'
                                        onClick={() => {
                                            setSelectId(item.id);
                                            setIsShowModal(true);
                                        }}
                                    >
                                        Sửa
                                    </button>
                                    <button className='btn btn-danger m-1' onClick={() => _handleDelete(item.id)}>
                                        Xóa
                                    </button>
                                </td>
                            </tr>
                        );
                    })
                ) : (
                    <tr>
                        <td colSpan={5} className='text-center'>
                            Không có dữ liệu
                        </td>
                    </tr>
                )}
            </tbody>
        );
    }

    return (
        <React.Fragment>
            <Loading show={isBusy} msg='Đang tải dữ liệu...' />
            <Breadcrumbs currentPage='Họa tiết thêu' parentPage='Quản lý Stock Photo' />
            <CommonTable data={datas} paging={paging} hideSearch renderAction={_renderAction} renderHeader={_renderHeader} renderBody={_renderBody} onFilter={_getData} />
            {isShowModal && (
                <PatternUploadModal
                    id={selectId}
                    isShowModal={isShowModal}
                    onClose={() => {
                        setIsShowModal(false);
                        setSelectId(0);
                    }}
                    saveSucceed={() => {
                        setIsShowModal(false);
                        setSelectId(0);
                        _getData(paging);
                    }}
                />
            )}
        </React.Fragment>
    );
}

export default EmbroideryPatternList;
